import React from 'react';

const DVTJCUVSearchCddJobOverviewContent = (props) => {
    const {overview} = props
    return (
        <>
            <div className='card card-default'>
                <div className='card-header'>
                    <h3 className='card-title text-bold'>Lần: {overview.service_use_times}</h3>
                </div>
                <div className='card-body'>
                    <div className={'row'}>
                        <p className={'col-sm-4'}>Step cao nhất: {overview.max_step}</p>
                        <p className={'col-sm-4'}>Số Receiver - Brief Sent: {overview.brief_sent_count}</p>
                        <p className={'col-sm-4'}>Số Receiver - CV sent: {overview.cv_sent_count}</p>
                        <p className={'col-sm-4'}>Số Job: {overview.job_count}</p>
                        <p className={'col-sm-4'}>Số ITV: {overview.itv_count}</p>
                        <p className={'col-sm-4'}>Số Offer: {overview.offer_count}</p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default DVTJCUVSearchCddJobOverviewContent;
